function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlay = function SvgIconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 17.5-8 4.8v-9.6z",
    style: {
      fill: "none",
      stroke: "#da1b85",
      strokeWidth: 3,
      strokeLinejoin: "round"
    },
    transform: "translate(-13 -11)"
  }));
};
export { SvgIconPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEzIDEzIiB2aWV3Qm94PSIwIDAgMTMgMTMiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyI+PHBhdGggZD0ibTIzLjUgMTcuNS04IDQuOHYtOS42eiIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6I2RhMWI4NTtzdHJva2Utd2lkdGg6MztzdHJva2UtbGluZWpvaW46cm91bmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMyAtMTEpIi8+PC9zdmc+";